import React from 'react'
import { SxProps, Theme, useTheme } from '@mui/material/styles'
import ButtonBase from '@mui/material/ButtonBase'

type Props = {
    isActive: boolean
    extraSx?: SxProps<Theme>
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}
const NavigationButtonBase = React.forwardRef<HTMLButtonElement | null, Props>(
    function NavigationButtonBase(props, ref) {
        const theme = useTheme()

        const inactiveStyles: SxProps<Theme> = {
            ...theme.typography.overline,
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '18px',
            letterSpacing: '2px',
            color: theme.palette.primary.main,
            backgroundColor: '#fff',
            border: '1px solid transparent',
            height: '100%',
            borderRadius: theme.spacing(2, 2, 0, 0),
            padding: theme.spacing(4),
            '&:hover': {
                backgroundColor: '#fff',
                borderBottom: `1px solid ${theme.palette.warning.main}`,
            },
            '&:focus': {
                backgroundColor: '#fff',
                border: `1px solid ${theme.palette.warning.main}`,
            },
            '& svg': {
                fontSize: '24px !important',
            },
        }

        const activeStyles: SxProps<Theme> = {
            ...inactiveStyles,
            svg: { color: theme.palette.warning.main },
            fontWeight: '700',
            borderBottom: `1px solid ${theme.palette.warning.main}`,
        }

        const iconStyle = props.isActive ? activeStyles : inactiveStyles

        const styles = Object.assign({}, iconStyle, props.extraSx)

        return (
            <ButtonBase
                sx={{
                    ...styles,
                    position: 'relative',
                    overflow: 'hidden',
                }}
                ref={ref}
                onClick={props.onClick}
            >
                {props.children}
            </ButtonBase>
        )
    }
)

export default NavigationButtonBase
